export default __webpack_public_path__ + "static/media/greenpipe-upsidedown.d12fe731.png";